import LockupVideoPreview from './lockupVideoPreview'

export default LockupVideoPreview
